// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/worth/value.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'worth.value',
	post: false,
	require: function(config, filter) { return sorted('worth.value', filter) > 0 },
	run: function(config, filter, data, query) {
		if (config.resultType === F.RESULT_COLLECTION) {
			query.order('COALESCE(c.collection_value, 0)', sortReverse('worth.value', filter), sortPriority('worth.value', filter))
		} else {
			query.order('COALESCE(g.game_worth_value, 0)', sortReverse('worth.value', filter), sortPriority('worth.value', filter))
		}
	}
}
